import React from "react";
import { ButtonLink } from "../ButtonLink";
import { Body } from "../Typography";
import {
  CollaboratorActions,
  CollaboratorContent,
  CollaboratorRowContainer,
  CollaboratorTextContent,
} from "./__styles__/CollaboratorList";
import { InheritedPermissionGroup } from "./types";

interface InheritedPermissionRowProps {
  group: InheritedPermissionGroup;
  onClick?: (group: InheritedPermissionGroup) => void;
}

export const InheritedPermissionRow = ({
  group,
  onClick,
}: InheritedPermissionRowProps) => {
  const collaboratorCount = group.collaborators.length;
  const countLabel =
    collaboratorCount === 1 ? "1 person" : `${collaboratorCount} people`;

  return (
    <CollaboratorRowContainer
      onClick={() => onClick?.(group)}
      style={{ cursor: onClick ? "pointer" : "default" }}
    >
      <CollaboratorContent>
        <CollaboratorTextContent>
          <Body type="emphasis" size="default" color="contentPrimary">
            {group.label}
          </Body>
          {group.description && (
            <Body type="regular" size="default" color="contentSecondary">
              {group.description}
            </Body>
          )}
        </CollaboratorTextContent>
      </CollaboratorContent>
      <CollaboratorActions>
        <ButtonLink
          styleVariant="primary"
          size="small"
          rightIconName="chevron-right"
          onClick={e => {
            e?.stopPropagation();
            onClick?.(group);
          }}
        >
          {countLabel}
        </ButtonLink>
      </CollaboratorActions>
    </CollaboratorRowContainer>
  );
};
